import type { ResourceArticle } from "@core-ui/ContextServices/ResourceService/store/ResourceStore";
import {
	ResourceServiceContext,
	type ResourceServiceType,
	ResourceStoreProvider,
} from "@core-ui/ContextServices/ResourceService/store/ResourceStore.provider";
import { type ReactElement, useContext } from "react";

interface ResourceServiceProps extends ResourceArticle {
	children: ReactElement;
}

// biome-ignore lint/complexity/noStaticOnlyClass: kk
abstract class ResourceService {
	static pendingLoads = new Set<Promise<void>>();

	static Provider({ children, provider, id, articleScope, articleCatalog }: ResourceServiceProps) {
		return (
			<ResourceStoreProvider
				articleCatalog={articleCatalog}
				articleScope={articleScope}
				id={id}
				provider={provider}
			>
				{children}
			</ResourceStoreProvider>
		);
	}

	static get value(): ResourceServiceType {
		return useContext(ResourceServiceContext);
	}

	static async waitForAllLoads(signal?: AbortSignal) {
		const yieldThread = () =>
			new Promise<void>((resolve) => {
				setTimeout(resolve, 0);
			});

		while (ResourceService.pendingLoads.size) {
			if (signal?.aborted) return;
			const pending = Array.from(ResourceService.pendingLoads);
			await Promise.race([Promise.allSettled(pending), yieldThread()]);
		}
	}
}

export type { ResourceServiceType } from "./store/ResourceStore.provider";
export default ResourceService;
